import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAviToMp4ConverterConfig } from '@/data/landingConfig/landingAviToMp4ConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AviToMp4Converter } from './schemaObject';

interface Props {}
const AviToMp4Converter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AviToMp4Converter} />
			<VideoLandingTemplate
				data={landingAviToMp4ConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default AviToMp4Converter;
